import { useAppSelector } from '@user/store/hooks'
import { FEATURES } from '@sales-center/common/tenantFeatures'
import { selectTenantFeatureById } from '@user/store/tenantFeatures'

export function useServiceCodesEnabled() {
  const feature = useAppSelector((state) =>
    selectTenantFeatureById(state, FEATURES.ServiceCodes),
  )

  return feature?.enabled ?? false
}
